import {createPivotTableReducer} from 'reducers/pivotTable'
import {combineReducers} from 'redux'

export const quotingContextNewDocumentsPivotTableKey = 'quotingContext.selected.newDocuments.pivotTable'

export default combineReducers({
  pivotTable: createPivotTableReducer({
    key: quotingContextNewDocumentsPivotTableKey,
    defaultSortColumn: 'folderName',
  }),
})
